//  @flow
import React from 'react';
import logo from '../../assets/jovi-logo.svg';
import './RegistrationComplete.css';
import { Link, Redirect } from 'react-router-dom';

export default class RegistrationComplete extends React.Component {
  render() {
    return (
      <div className='RegistrationComplete' >
        {
          (!this.props.location.state ||
          this.props.location.state.referrer !== '/register/step2') &&
          <Redirect to='/' />
        }
        <Link to='/' className='RegistrationComplete-JoviLogo'>
          <img src={logo} alt='Jovi Inc.' className='RegistrationForm-logo' />
        </Link>
        <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none" /><path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" /></svg>
        <div className='RegisrationComplete-message'>
          <p className='awesome'>Awesome!</p>
          <p>Please check your email for verification instructions</p>
        </div>
      </div >

    );
  }
}


// WEBPACK FOOTER //
// ./src/components/RegistrationComplete/RegistrationComplete.jsx